// devices_stats sends hours_recorded as a duration string ("1:23:45", or
// "1 day, 0:00:00" at the 24 h cap) and "-" when nothing was recorded.
// Returns a short label such as "1h 23m", or '' when there is no value.
export function formatHoursRecorded(value) {
  if (value === null || value === undefined) return '';
  if (typeof value === 'number') {
    return Number.isFinite(value) ? `${value}h` : '';
  }
  const text = String(value).trim();
  const match = text.match(/^(?:(\d+) days?, )?(\d+):(\d{2})(?::\d{2}(?:\.\d+)?)?$/);
  if (match) {
    const hours = Number(match[1] || 0) * 24 + Number(match[2]);
    return `${hours}h ${Number(match[3])}m`;
  }
  // A bare number of hours, e.g. "0" or "2.5".
  if (text !== '' && Number.isFinite(Number(text))) return `${Number(text)}h`;
  return '';
}
